import { Flex } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';

import { FORMAT_TIME_DISPLAY, WIDTH_CARD_TASK_BIG, WIDTH_CARD_TASK_MEDIUM } from '../const';
import { TaskPositionType } from '../types';
import CalendarTaskBodyBadge from './calendarTaskBodyBadge';

interface ICalendarTaskBodySecondLine {
    task: TaskPositionType;
    widthTaskBody: number;
}

const CalendarTaskBodySecondLine: React.FC<ICalendarTaskBodySecondLine> = ({ task, widthTaskBody }) => {
    const badge = <CalendarTaskBodyBadge task={task} widthTaskBody={widthTaskBody} />;

    return (
        <>
            {task.height > 1 && (
                <Flex vertical>
                    <Flex
                        gap={10}
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: 10,
                        }}
                    >
                        {task.height > 3 && DateTime.fromISO(task.start_datetime).toFormat(FORMAT_TIME_DISPLAY)}
                        {widthTaskBody >= WIDTH_CARD_TASK_MEDIUM && widthTaskBody < WIDTH_CARD_TASK_BIG ? badge : null}
                    </Flex>
                    {widthTaskBody < WIDTH_CARD_TASK_MEDIUM ? badge : null}
                </Flex>
            )}
        </>
    );
};

export default CalendarTaskBodySecondLine;
